import type { FaireBrandEntity } from "../../entity_types/brand";

export const baggu: FaireBrandEntity = {
  token: "baggu",
  type: "brand",
  name: "Baggu",
  logoUrl:
    "https://cdn.prerelease.faire.dev/fastly/627e7698030e5de81da99722095df84a64991c7f3f70414a4b879ddfa5fe0e0e.jpeg",
  minimumOrderDollars: 100,
  rating: 4.9,
  location: "San Francisco, CA",
  tags: ["bags", "accessories", "sustainable"],
  categoryTokens: ["cat_accents-all"],
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "atc-entity-migration",
  },
};
